// noinspection ES6UnusedImports
import React, {Fragment} from 'react';
import {Logo, Typography} from '@bonprix/design-system';

export default function AcceptedPaymentSection({
                                                   texts,
                                                   paymentTypes = [],
                                                   country,
                                                   guest
                                               }) {

    const isAnonymous = paymentTypes?.length === 0;

    const renderLogos = (() => {

            return (
                <>
                    {(paymentTypes.includes('BILLING') || isAnonymous) && (
                        <>
                            <li className="payment-box">
                                <Logo variant="payment-invoice" />
                                <span className="sr-only">{texts.checkout__payment_billing_screenreader_label}</span>
                            </li>
                            {country === 'de' && (
                                <li className="payment-box">
                                    <Logo variant="payment-instalment" />
                                    <span className="sr-only">{texts.checkout__payment_installment_screenreader_label}</span>
                                </li>
                            )}
                        </>
                    )}

                    {paymentTypes.includes('DEPOSIT') && (
                        <li className="payment-box">
                            <Logo variant="payment-instalment" />
                            <span className="sr-only">{texts.checkout__payment_installment_screenreader_label}</span>
                        </li>
                    )}

                    {(paymentTypes.includes('REVOLVING_CREDIT') || (isAnonymous && country === 'at')) && (
                        <li className="payment-box">
                            <Logo variant="payment-part-payment" />
                            <span className="sr-only">{texts.checkout__payment_revolvingcredit_screenreader_label}</span>
                        </li>
                    )}

                    {(paymentTypes.includes('BANK_COLLECTION') || (isAnonymous && country === 'de')) && (
                        <li className="payment-box">
                            <Logo variant="payment-sepa" />
                            <span className="sr-only">{texts.checkout__payment_sepa_screenreader_label}</span>
                        </li>
                    )}

                    {(paymentTypes.includes('PAYPAL') || isAnonymous) && (
                        <li className="payment-box">
                            <Logo variant="payment-paypal" />
                            <span className="sr-only">{texts.checkout__payment_paypal_screenreader_label}</span>
                        </li>
                    )}

                    {(paymentTypes.includes('CREDIT_CARD') || isAnonymous) && (
                        <>
                            <li className="payment-box">
                                <Logo variant="payment-visa" />
                                <span className="sr-only">{texts.checkout__payment_visa_screenreader_label}</span>
                            </li>
                            <li className="payment-box">
                                <Logo variant="payment-mastercard" />
                                <span className="sr-only">{texts.checkout__payment_mastercard_screenreader_label}</span>
                            </li>
                            {country === 'de' && (
                                <li className="payment-box">
                                    <Logo variant="payment-american-express" />
                                    <span className="sr-only">{texts.checkout__payment_amex_screenreader_label}</span>
                                </li>
                            )}
                            <li className="payment-box">
                                <Logo variant="payment-diners-club" />
                                <span className="sr-only">{texts.checkout__payment_dinersclub_screenreader_label}</span>
                            </li>
                            <li className="payment-box">
                                <Logo variant="payment-discover" />
                                <span className="sr-only">{texts.checkout__payment_discover_screenreader_label}</span>
                            </li>
                        </>
                    )}

                    {(paymentTypes.includes('PREPAID') || isAnonymous) && (
                        <li className="payment-box">
                            <Logo variant="payment-prepayment" />
                            <span className="sr-only">{texts.checkout__payment_prepayment_screenreader_label}</span>
                        </li>
                    )}

                </>
            );
        }
    );

    return (
        <div className="accepted-payments-section">
            <Typography variant="body2" align="left">
                {guest
                    ? texts.checkout__accepted_payment_types_guest
                    : texts.cot09_accepted_payment_types
                }
            </Typography>
            <ul className="accepted-payments pl-0">
                {renderLogos()}
            </ul>
        </div>
    );
}
